export const environment = {


  production: true,
  apiUrl1: '#{apiUrl1}#',
  apiUrl2: '#{apiUrl2}#',
  apiSubscription: {
    OcpApimSubscriptionKey: '#{OcpApimSubscriptionKey}#',
  },
  appInsights: {
    instrumentationKey: '#{InstrumentationKey}#',
  },
  gtmId: '#{gtmId}#',
  showmodal: '#{showmodal}#'


 /*
  production: true,
  showmodal: true,
  apiUrl1: 'https://apim-segurossura-dev.azure-api.net/seguroxkm/api',
  //apiUrl2: 'http://localhost:4000/api',
  apiSubscription: {
    OcpApimSubscriptionKey: '578c3c32590e4af3b52f26847408e2d9'
  },
  appInsights: {
    instrumentationKey: 'e979d161-7f6c-49ae-be0a-33ae6453fa47'
  },
  gtmId: 'GTM-MR2BWBQ', 
   */
};
